import styled from 'styled-components';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

const StyledArrowUpwardIcon = withStyles({
  root: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#69b34c',
  },
})(ArrowUpward);

const StyledArrowDownwardIcon = withStyles({
  root: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ff6161',
  },
})(ArrowDownward);

export const ArrowUpIcon = styled(StyledArrowUpwardIcon)``;

export const ArrowDownIcon = styled(StyledArrowDownwardIcon)``;

export const Container = styled.div`
  transition: all 0.3s ease-in;
  border-radius: 7px;
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 279px;
  gap: 25px;
  padding: 20px;
  &:hover {
    cursor: ${props => (props.onClick ? 'pointer' : 'auto')};
    box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  }
`;

export const Title = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  text-transform: uppercase;
  color: black;
`;

export const Statistics = styled.span`
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: ${props => props.fontSize || '34px'};
  color: #007ade;
`;

export const ResendStats = styled.span`
  font-size: 11px;
  color: #707070;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  padding: 3px 3px 0;
`;

export const Row = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

export const Column = styled.span`
  display: flex;
  flex-direction: column;
`;

export const Bold = styled.b`
  font-size: 12px;
`;

export const Value = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
`;

export const EmptySpace = styled.span`
  height: 20px;
`;
